export const ROUTE_PATH = {
  login: '/',
  dashboard: '/dashboard',
  mileageList: '/mileage',
  newMileage: '/mileage/add',
  scholarship: '/scholarship/apply',
  myPage: '/my',
};
